import React from 'react';
import {
    Layout,
    Input,
    Row,
    Col,
    Button,
    message,
    Space,
    Modal
} from 'antd';
import { Link, withRouter } from 'react-router-dom';
import Footer from '../components/Footer';
import SNSBox from '../components/SNSBox';
import {  sendComment } from '../services/demoService';

import Logo from '../../resources/img/logo_w.png';
import { MessageOutlined } from '@ant-design/icons';
import MadFactory from "../../resources/img/madfactory_thumb.png";
import ToU from "../../resources/img/tou_thumb.png";
import CubeFit from "../../resources/img/cubefit_thumb.png";


const { Header, Content } = Layout;
const { TextArea } = Input;


const pages = [
    {
        thumb: MadFactory,
        link: '/madFactory'
    },
    {
        thumb: ToU,
        link: '/tou'
    },
    {
        thumb: CubeFit,
        link: '/cubeFit'
    }
];


class Feedback extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            report: "",
            type: "",
        }


        this._onSendReport = this._onSendReport.bind(this);
        this._onChangeReport = this._onChangeReport.bind(this);
    }

    componentDidMount() {
        const { type } = this.props.match.params;

        this.setState({
            fetchDemo: true,
            type
        });
    }

    _onSendReport() {
        const { report } = this.state;

        if(report === "") return;
        this.setState({loading: true});



        sendComment({
            code: this.state.type,
            comment: report
        })
            .then((res) => {
                message.success('Thank you for your feedback!');
                this.setState({loading: false});
            })
            .catch((err) => {
                message.error("Error! Please submit later.");
                this.setState({loading: false});
            })
    }


    _onChangeReport(comment) {
        this.setState({report: comment.target.value});
    }

    render() {
        const { type, loading } = this.state;

        return (
            <Layout className={'fadeIn full-layout feedback'}>
                <Header className={'header home__header'}>
                    <Link className={'home__logo'} to={"/"}>
                        <img className={'home__logo__img'} src={Logo} alt="logo"/>
                        <p className={'home__logo__text'}>GAME</p>
                    </Link>
                </Header>
                <SNSBox/>
                <Content>
                    {/*<div>*/}
                        {/*{*/}
                            {/*pages.map((page) => {*/}
                                {/*let show = page.link === "/" + type;*/}
                                {/*return (*/}
                                    {/*<div key={page.title} className={`feedback__box ${!show && 'feedback__box--hide'}`}>*/}
                                        {/*<img className={'feedback__img'} src={page.thumb} alt="img"/>*/}
                                    {/*</div>*/}
                                {/*);*/}
                            {/*})*/}
                        {/*}*/}
                    {/*</div>*/}
                    <div className={'feedback__comment'}>
                        <div className={'feedback__comment__divider'}/>
                        <Space direction={"vertical"} className={'feedback__comment__box'}>
                            <p className={"feedback__comment__title"}>Feedback</p>
                            <p className={"feedback__comment__desc"}>Help us make better games!</p>
                            <TextArea onChange={this._onChangeReport} placeholder={"How was the demo? Please share your thoughts!"} rows={5}/>
                            <Button loading={loading} size={'large'} block type={'primary'} onClick={this._onSendReport}>Submit</Button>
                        </Space>
                        <div className={'feedback__comment__divider feedback__comment__divider--bottom'}/>
                    </div>
                </Content>
                <Footer />
            </Layout>
        );
    }
}

export default withRouter(Feedback);